<div class="login-page" style="min-height: auto; padding: 0; background: transparent; align-items: stretch;">
  <mat-card class="login-card" style="max-width: 520px; box-shadow: none;">
    <h1>Change password</h1>
    <p class="subtitle">Update your password. Other sessions may be signed out.</p>

    <form [formGroup]="form" (ngSubmit)="submit()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Current password</mat-label>
        <input matInput type="password" formControlName="currentPassword" autocomplete="current-password" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>New password</mat-label>
        <input matInput type="password" formControlName="newPassword" autocomplete="new-password" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Confirm password</mat-label>
        <input matInput type="password" formControlName="confirmPassword" autocomplete="new-password" />
      </mat-form-field>

      @if (error()) { <div class="error-banner">{{ error() }}</div> }
      @if (message()) { <div class="success-banner">{{ message() }}</div> }

      <button mat-raised-button color="primary" class="full-width submit-btn" type="submit" [disabled]="loading() || form.invalid">
        @if (loading()) { <mat-spinner diameter="22"></mat-spinner> } @else { Update password }
      </button>
    </form>
  </mat-card>
</div>
